import React from 'react';
import config from '../config.json';

const About = () => {
  const aboutConfig = config.pages.about;

  return (
    <div className="about">
      <div className="container">
        <h1>{aboutConfig.title.zh}</h1>
        <section className="company">
          <h2>{aboutConfig.company.history.zh}</h2>
          <p>{aboutConfig.company.founded.zh}</p>
          <p>{aboutConfig.company.description.zh}</p>
        </section>
        <section className="mission">
          <h2>{aboutConfig.mission.title.zh}</h2>
          <ul>
            {aboutConfig.mission.items.map((item, index) => (
              <li key={index}>{item.zh}</li>
            ))}
          </ul>
        </section>
        <section className="team">
          <h2>{aboutConfig.team.title.zh}</h2>
          <p>{aboutConfig.team.description.zh}</p>
          <div className="team-members">
            {aboutConfig.team.members.map((member, index) => (
              <div key={index} className="team-member">
                <h3>{member.name.zh}</h3>
                <p>{member.description.zh}</p>
              </div>
            ))}
          </div>
        </section>
        <section className="achievements">
          <h2>{aboutConfig.achievements.title.zh}</h2>
          <ul>
            {aboutConfig.achievements.items.map((item, index) => (
              <li key={index}>{item.zh}</li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
};

export default About;